import { z } from "zod";
/**
 * Validation schemas using Zod
 */
// Swedish organization number (10 digits, can have hyphen)
export const organizationNumberSchema = z
    .string()
    .regex(/^\d{6}-?\d{4}$/, "Organisationsnumret måste vara 10 siffror (XXXXXX-XXXX)")
    .transform((val) => val.replace("-", ""));
// Swedish personal ID (12 digits, can have hyphen)
export const personalIdSchema = z
    .string()
    .regex(/^\d{8}-?\d{4}$/, "Personnumret måste vara 12 siffror (YYYYMMDD-XXXX)")
    .transform((val) => val.replace("-", ""));
// Email
export const emailSchema = z.string().email("Ogiltig e-postadress");
// Password (min 8 chars)
export const passwordSchema = z
    .string()
    .min(8, "Lösenordet måste vara minst 8 tecken");
// User registration
export const registerSchema = z.object({
    email: emailSchema,
    password: passwordSchema,
    firstName: z.string().min(1, "Förnamn krävs").optional(),
    lastName: z.string().min(1, "Efternamn krävs").optional(),
    acceptTerms: z.boolean().refine((val) => val === true, {
        message: "Du måste godkänna användarvillkoren",
    }),
    acceptPrivacy: z.boolean().refine((val) => val === true, {
        message: "Du måste godkänna integritetspolicyn",
    }),
});
// User login
export const loginSchema = z.object({
    email: emailSchema,
    password: z.string().min(1, "Lösenord krävs"),
});
// Company creation
export const createCompanySchema = z.object({
    organizationNumber: organizationNumberSchema,
    name: z.string().min(1, "Företagsnamn krävs"),
    type: z.enum(["AB", "EF", "HB", "KB"]).default("AB"),
    seatMunicipality: z.string().optional(),
});
// Board member
export const boardMemberSchema = z.object({
    name: z.string().min(1, "Namn krävs"),
    role: z.enum([
        "ordforande",
        "ledamot",
        "suppleant",
        "vd",
        "revisor",
    ]),
    personalId: personalIdSchema.optional(),
});
// Dividend proposal
export const dividendProposalSchema = z.object({
    proposedDividend: z.number().min(0, "Utdelningen kan inte vara negativ"),
});
// Fiscal year
export const fiscalYearSchema = z.object({
    startDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Datum måste vara YYYY-MM-DD"),
    endDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Datum måste vara YYYY-MM-DD"),
});
